import React from "react";
import { Card } from "react-bootstrap";
import { FaGamepad, FaRegHandPointRight } from "react-icons/fa";

interface PickAndRankModeRulesCardProps {
	numberOfMen: number;
	numberOfWomen: number;
}

const PickAndRankModeRulesCard: React.FC<PickAndRankModeRulesCardProps> = ({
	numberOfMen,
	numberOfWomen,
}) => {
	return (
		<Card className="mb-3 shadow bg-secondary text-white border-0">
			<Card.Header className="fs-3 fw-bold">
				<FaGamepad className="me-2 mb-1" />
				Pick and Rank Mode
			</Card.Header>
			<Card.Body style={{ fontSize: "0.8rem" }}>
				<Card.Text>
					<FaRegHandPointRight className="me-2" />
					You must select {numberOfMen} Men, and {numberOfWomen} Women, for your
					team.
				</Card.Text>
				<Card.Text>
					<FaRegHandPointRight className="me-2" />
					Build your team and guess the podium order. 1st, 2nd, 3rd...
				</Card.Text>
				<Card.Text>
					<FaRegHandPointRight className="me-2" />
					+100 points for each selected rider that finishes in the top{" "}
					{numberOfMen} for men and top {numberOfWomen} for women
				</Card.Text>
				<Card.Text>
					<FaRegHandPointRight className="me-2" />
					+100 points for every podium spot guessed correctly.
				</Card.Text>
				<Card.Text>
					<FaRegHandPointRight className="me-2" />
					+100 points for correctly guessing the Best Trick or People's Choice
					award winner.
				</Card.Text>
			</Card.Body>
		</Card>
	);
};

export default PickAndRankModeRulesCard;
